import styled from '@emotion/styled'
import { useSelector } from 'react-redux'
import { selectProductCategory } from '../../../../flux/selectors/products'
import { selectCurrentCollectionIndex } from '../../../../flux/selectors/ux'

const StyledProductCategory = styled.div(({ theme: { colors } }) => ({
  backgroundColor: colors.light_grey,
  color: colors.mid_grey,
  fontSize: '12px',
  fontWeight: 'bold',
  textAlign: 'center',
  textTransform: 'uppercase',
}))

const ProductCategory = () => {
  const collectionIndex = useSelector(selectCurrentCollectionIndex)
  const currentCategory = useSelector(selectProductCategory(collectionIndex))

  return currentCategory ? (
    <StyledProductCategory data-test="ProductCategory">
      {currentCategory}
    </StyledProductCategory>
  ) : null
}

export default ProductCategory
